export const IconSearchMagnifyingGlass: {
  name: 'icon_search_magnifying_glass-b3475bfe05a9'
} = {
  name: 'icon_search_magnifying_glass-b3475bfe05a9'
}
